import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, IconButton } from '@mui/material'
import { Delete } from '../../../../../assets/img/icons'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { LoaderDots, Confirmation } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import { GridWrapper, TableWrapper } from './style'
import { getObjectAsArray } from '../../../../../util'

const Grid = ({ refreshData }) => {
  const [gridData, setGridData] = useState([])
  const [loader, setLoader] = useState(true)
  const [deleteObject, setDeleteObject] = useState(null)
  const { company } = useGlobalStore()

  const onload = async () => {
    setLoader(true)
    const payload = { organizationId: company?.OrganizationId }
    const response = await keywordManagement.getOrganizationAggregationKeywordDetailsApi(payload)
    setGridData(getObjectAsArray(response, 'adv'))
    setTimeout(() => {
      setLoader(false)
    }, 500)
  }

  const deleteFunc = async (obj) => {
    if (obj.KeywordSubTypeValue.length > 0) {
      const payload = { organizationId: company?.OrganizationId, keywordSubTypeValue: obj.KeywordSubTypeValue, parentKeywordTypeValue: obj.KeywordTypeValue, parentKeywordNotesValue: obj.KeywordNotesValue, parentKeywordValue: obj.KeywordValue, delete: true }
      await keywordManagement.setOrganizationAggregationKeywordSubTypeApi(payload)
    } else if (obj.KeywordTypeValue.length > 0) {
      const payload = { organizationId: company?.OrganizationId, keywordTypeValue: obj.KeywordTypeValue, parentKeywordNotesValue: obj.KeywordNotesValue, parentKeywordValue: obj.KeywordValue, delete: true }
      await keywordManagement.setOrganizationAggregationKeywordTypeApi(payload)
    } else if (obj.KeywordNotesValue.length > 0) {
      const payload = { organizationId: company?.OrganizationId, keywordNotesValue: obj.KeywordNotesValue, parentKeywordValue: obj.KeywordValue, delete: true }
      await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload)
    } else if (obj.KeywordValue.length > 0) {
      const payload = { organizationId: company?.OrganizationId, keywordValue: obj.KeywordValue, delete: true }
      await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload)
    }
    setDeleteObject(null)
    onload()
  }

  useEffect(() => {
    onload()
  }, [refreshData])

  useEffect(() => {
    onload()
  }, [company?.OrganizationId])

  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          {gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                <TableCell>Keyword</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Sub Type</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row.KeywordValue}</TableCell>
                    <TableCell>{row.KeywordNotesValue}</TableCell>
                    <TableCell>{row.KeywordTypeValue}</TableCell>
                    <TableCell>{row.KeywordSubTypeValue}</TableCell>
                    <TableCell className='actionWrapper'>
                      {/* <IconButton className={`${row.IsDeleted ? 'IsDeleted' : ''}`} onClick={() => deleteFunc(row)}><Delete active={row.IsDeleted} /></IconButton> */}
                      <IconButton className={`${row.IsDeleted ? 'IsDeleted' : ''}`} onClick={() => setDeleteObject(row)}><Delete active={row.IsDeleted} /></IconButton>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}

          {deleteObject && <Confirmation
            open={true}
            title='Are you sure you want to delete this row?'
            onClose={() => setDeleteObject(null)}
            onCancel={() => setDeleteObject(null)}
            onSubmit={() => deleteFunc(deleteObject)}
          />}

          {loader && <LoaderDots /> }
          {!loader && gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

Grid.propTypes = {
  refreshData: PropTypes.number
}

export default Grid
